<div class="row">
    <div class="col-sm-5">
        <kendo-expansionpanel [title]="'Address Search'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col">
                    <kendo-tabstrip>
                        <kendo-tabstrip-tab title="Full Address" [selected]="true">
                            <ng-template kendoTabContent>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <label class="fw-bold">Full Address</label>
                                        <input type="text" class="form-control" [(ngModel)]="address" />
                                    </div>
                                    <div class="col-sm-4">
                                        <button type="button" class="btn btn-primary" (click)="getGeocodeFromFullAddress()" [disabled]="address == ''">Get City From Address</button>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab title="Structured Address">
                            <ng-template kendoTabContent>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">Street Number</label>
                                                <input type="text" class="form-control" [(ngModel)]="streetNumber" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">Street Name</label>
                                                <input type="text" class="form-control" [(ngModel)]="streetName" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">City</label>
                                                <input type="text" class="form-control" [(ngModel)]="cityName" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">Country</label>
                                                <select name="countryCode" [(ngModel)]="countryCode" (change)="countryChanged($event)" class="form-select" *ngIf="countryList.length > 0">
                                                    <option value="0">- Select Country -</option>
                                                    <option *ngFor="let country of countryList" value="{{country.abbrev}}">{{country.abbrev}} - {{country.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">State/Province</label>
                                                <select name="stateID" [(ngModel)]="city.stateID" (change)="stateChanged($event)" class="form-select" [ngClass]="city.stateID > 0 ? '' : 'border-danger'" [disabled]="countryID==0">
                                                    <option value="0">- Select State -</option>
                                                    <option *ngFor="let state of stateList" value="{{state.stateId}}">{{state.name}} - {{state.abbrev}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label class="fw-bold">Postal Code</label>
                                                <input type="text" class="form-control" [(ngModel)]="postalCode" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <button type="button" class="btn btn-primary" (click)="getGeocodeFromStructuredAddress()" [disabled]="cityName == '' || stateID == '' || postalCode == '' || countryID == ''">Get City From Address</button>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-tabstrip-tab>
                    </kendo-tabstrip>
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Lat/Lon Search'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col-sm-4">
                    <label class="fw-bold" [ngClass]="city.latitude == undefined || city.latitude == null ? 'text-danger' : ''">Lat</label>
                    <input type="number" class="form-control" [(ngModel)]="city.latitude" [ngClass]="city.latitude == undefined || city.latitude == null ? 'border-danger' : ''" />
                </div>
                <div class="col-sm-4">
                    <label class="fw-bold" [ngClass]="city.longitude == undefined || city.longitude == null ? 'text-danger' : ''">Lon</label>
                    <input type="number" class="form-control" [(ngModel)]="city.longitude" [ngClass]="city.longitude == undefined || city.longitude == null ? 'border-danger' : ''" />
                </div>
                <div class="col-sm-4">
                    <button type="button" class="btn btn-primary" (click)="getGeocodeFromLatLon()" [disabled]="city.latitude == undefined || city.latitude == null || city.longitude == undefined || city.longitude == null">Get City From Lat/Lon</button>
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Map Search Result'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col">
                    <label class="fw-bold">City</label>
                    <input type="text" class="form-control" [(ngModel)]="geoCoord.cityName" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">State/Province</label>
                    <input type="text" class="form-control" [(ngModel)]="geoCoord.state" disabled />
                </div>
                <div class="col-sm-6" *ngIf="canOverrideStateID()">
                    <label class="fw-bold">Manual</label>
                    <select name="stateIDOverride" [(ngModel)]="stateIDOverride" (change)="stateIDOverrideChanged()" class="form-select">
                        <option value="0">- Select State -</option>
                        <option *ngFor="let state of stateList" value="{{state.stateId}}">{{state.name}} - {{state.abbrev}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Zip</label>
                    <input type="text" class="form-control" [(ngModel)]="geoCoord.zip" disabled />
                </div>
                <div class="col-sm-6" *ngIf="canOverrideZip()">
                    <label class="fw-bold">Manual</label>
                    <input type="text" class="form-control" [(ngModel)]="zipOverride" (change)="zipOverrideChanged()" />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Country</label>
                    <input type="text" class="form-control" [(ngModel)]="geoCoord.country" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Timezone</label>
                    <input type="text" class="form-control" [(ngModel)]="timeZone.azureMapStandardTimeZoneName" disabled />
                </div>
            </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel [title]="'Zip3 Result'"
                              [subtitle]="''"
                              [expanded]="true">
            <div class="row">
                <div class="col-sm-8">
                    <label class="fw-bold">Country</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.countryName" disabled />
                </div>
                <div class="col-sm-4">
                    <label class="fw-bold">Abbr</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.countryAbbrev" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Region</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.regionName" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-8">
                    <label class="fw-bold">State/Province></label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.stateName" disabled />
                </div>
                <div class="col-sm-4">
                    <label class="fw-bold">Abbr</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.stateAbbrev" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Market</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.marketName" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Zip3</label>
                    <input type="text" class="form-control" [(ngModel)]="searchZip3.zip3" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button type="button" class="btn btn-primary m-1" (click)="saveCity()">Add City</button>
                    <button type="button" class="btn btn-secondary m-1" (click)="clearForm()">Clear Form</button>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
    <div class="col-sm-7">
        <div class="row">
            <div class="col" style="height: 600px;">
                <openlayers-map (onGetCoordinate)="setCoordinate($event)" #olMap></openlayers-map>
            </div>
        </div>
    </div>
</div>
